import React from 'react';
import { Timeline } from 'shared-components';

export const BCM_SHORT_WIZARD_STEPS = [
  { id: '1', label: 'Your Information' },
  { id: '2', label: 'Business Details' },
  { id: '3', label: 'Confirm' },
];

interface BCMShortTimelineProps {
  currentStep: number;
}

// Thin wrapper around shared-components' Timeline — keeps the
// container padding/border consistent with Volt's BCMSignupTimeline.
export const BCMShortTimeline: React.FC<BCMShortTimelineProps> = ({ currentStep }) => (
  <div className="pb-[20px] pt-[10px] px-[20px] mx-[20px] border-b border-dawn2">
    <Timeline steps={BCM_SHORT_WIZARD_STEPS} currentStep={currentStep} containerProps={{ className: 'py-0' }} />
  </div>
);
